module.exports = __webpack_public_path__ + "media/assets/images/flags/bh-cd0ddce6dc5b12160bfd43177cd27a40.svg";